import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
import "firebase/analytics";
import "firebase/storage";

const config = {
  apiKey: process.env.VUE_APP_FB_apiKey,
  authDomain: process.env.VUE_APP_FB_authDomain,
  projectId: process.env.VUE_APP_FB_projectId,
  storageBucket: process.env.VUE_APP_FB_storageBucket,
  messagingSenderId: process.env.VUE_APP_FB_messagingSenderId,
  appId: process.env.VUE_APP_FB_appId,
  measurementId: process.env.VUE_APP_FB_measurementId
};

firebase.initializeApp(config);
firebase.analytics();

// utils
const db = firebase.firestore();
const auth = firebase.auth();
const storageService = firebase.storage();

// collection references
const usersCollection = db.collection("users");
const postsCollection = db.collection("posts");
const topicsCollection = db.collection("topics");
const liveSessionRef = db.collection("liveSession").doc("liveSession");
const commentsCollection = db.collection("comments");
const likesCollection = db.collection("likes");
const reactionsCollection = db.collection("reactions");
const notificationCollection = db.collection("notifications");
const projectsCollection = db.collection("projects");
const remindersCollection = db.collection("reminders");
const projectCommentsCollection = db.collection("projectComments");
const liveSessionChatCollection = db.collection("liveSessionChats");
const freeBundlesCollection = db.collection("freeBundles");
const userNameCollection = db.collection("usernames");

const functions = firebase.functions();

if (process.env.VUE_APP_USE_EMULATOR === "true") {
  functions.useEmulator("localhost", 5001);
}

const canTakePart = () => {
  if (!auth.currentUser) {
    return false;
  }
  if (
    !auth.currentUser.displayName ||
    auth.currentUser.displayName.length < 3
  ) {
    return false;
  }

  return true;
};

// export utils/refs
export {
  db,
  firebase,
  auth,
  storageService,
  usersCollection,
  postsCollection,
  commentsCollection,
  likesCollection,
  reactionsCollection,
  topicsCollection,
  notificationCollection,
  projectsCollection,
  remindersCollection,
  projectCommentsCollection,
  functions,
  canTakePart,
  liveSessionChatCollection,
  liveSessionRef,
  freeBundlesCollection,
  userNameCollection
};
